import Canada from './Canada'
import China from './China'
import Default from './Default'
import SouthKorea from './SouthKorea'
import UnitedStates from './UnitedStates'

type ConsentLanguageProps = GeneralConsentLanguageProps & {
  country: string
  implicitOptIn: boolean
}

export interface GeneralConsentLanguageProps {
  fieldName: string
  privacyStatementHref: string
  emailSubscriptionSettingsLinkHref: string
  hasPhone?: boolean
  exampleFields: string[]
  listExampleFields?: boolean
  labelClass?: string
  formControlClass?: string
  noticeClass?: string
  children: React.ReactNode
  onValidationChange?: (isValid: boolean) => void
  emphasizedTextForKoreaClass?: string
}

function ConsentLanguage({country, children, implicitOptIn, ...props}: ConsentLanguageProps) {
  const Component = getComponent(country, {implicitOptIn})

  // eslint-disable-next-line react-hooks/static-components
  return <Component {...props}>{children}</Component>
}

function getComponent(country: string, options: {implicitOptIn: boolean}): React.FC<GeneralConsentLanguageProps> {
  switch (country) {
    case 'CA':
      return Canada
    case 'CN':
      return China
    case 'KR':
      return SouthKorea
    case 'US':
      if (options.implicitOptIn) {
        return UnitedStates
      }

      return Default
    default:
      return Default
  }
}

export default ConsentLanguage
